import React, { FC } from 'react';

import { Box, CircularProgress } from '@mui/material';

const LegalLoading: FC = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '50vh',
    }}
  >
    <CircularProgress />
  </Box>
);

export default LegalLoading;
